import request from '@/utils/request.js'
import { V3 } from '@/utils/config.js'

export function getSettings() {
    return request({
        url: '/'+ V3 +'/settings',
        method: 'get',
    })
}

export function updateSettings(data) {
    return request({
        url: '/'+ V3 +'/settings',
        method: 'patch',
        data
    })
}

